<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="card-title" id="basic-layout-form">{{ 'sendSmsMessage.title' | translate }}</h4>
      <p class="mb-0">{{ 'sendSmsMessage.text' | translate: currentObject }}</p>
    </div>
    <div class="card-body">
      <div [class]="hasDesktopView ? 'px-3' : 'px-2'">
        <form class="form" #smsMessageForm="ngForm" (ngSubmit)="onSubmit(smsMessageForm)">
          <div class="form-body">
            <h4 class="form-section">
              <i class="ft-cpu"></i> {{ 'sendSmsMessage.detailsHeader' | translate }}
            </h4>

            <!-- SmsMessageId -->
            <div class="form-group">
              <label for="SmsMessageId">{{ 'sendSmsMessage.smsMessageIdFieldLabel' | translate }}</label>
              <input class="form-control" name="SmsMessageId" #SmsMessageId="ngModel"
                     [(ngModel)]="currentObject.SmsMessageId"
                     placeholder="{{'sendSmsMessage.smsMessageIdFieldPlaceHolder' | translate}}"
                     readonly="readonly">
            </div>

            <!-- Sender -->
            <div class="form-group">
              <label for="Sender">{{ 'sendSmsMessage.senderFieldLabel' | translate }}</label>
              <input class="form-control" [maxLength]=11 name="Sender" #Sender="ngModel"
                     [(ngModel)]="currentObject.Sender"
                     placeholder="{{'sendSmsMessage.senderFieldPlaceHolder' | translate}}"
                     required>
            </div>

            <!-- RecipientPhonenumber -->
            <div class="form-group">
              <label
                for="RecipientPhonenumber">{{ 'sendSmsMessage.recipientPhonenumberFieldLabel' | translate }}</label>
              <input class="form-control" name="RecipientPhonenumber" #RecipientPhonenumber="ngModel"
                     [(ngModel)]="currentObject.RecipientPhonenumber"
                     placeholder="{{'sendSmsMessage.recipientPhonenumberFieldPlaceHolder' | translate}}" required
                     minlength="10" maxlength="12" ngModel
                     [ngModelOptions]="{updateOn: 'blur'}" pattern="^(((\+31|0)6){1}[1-9]{1}[0-9]{7})$"/>
              <small class="form-text text-muted danger"
                     *ngIf="(!RecipientPhonenumber.valid) && (RecipientPhonenumber.dirty || RecipientPhonenumber.touched)">
                {{ 'sendSmsMessage.recipientPhonenumberInformationText' | translate }}
              </small>
            </div>

            <!-- Content -->
            <div class="form-group">
              <label for="Content">{{ 'sendSmsMessage.contentFieldLabel' | translate }}</label>
              <textarea class="form-control" [maxLength]=160 name="Content" #Content="ngModel"
                        [(ngModel)]="currentObject.Content"
                        placeholder="{{'sendSmsMessage.contentFieldPlaceHolder' | translate}}"
                        rows="2" required (keyup)=contentChanged()></textarea>
              {{ contentLength }}
            </div>
          </div>
          <div class="form-actions">
            <button class="btn btn-raised btn-raised btn-warning mr-1" type="button"
                    (click)="resetForm(smsMessageForm)">
              <i class="ft-x"></i> {{ 'buttons.resetText' | translate }}
            </button>
            <button [disabled]="!smsMessageForm.valid" class="btn btn-raised btn-raised btn-primary mr-1" type="submit">
              <i
                class="ft-check-square"></i> {{ hasDesktopView ? ('buttons.saveAndSendText' | translate) : ('buttons.sendText' | translate) }}
            </button>
            <button type="button" class="btn btn-secondary btn-raised mr-1" (click)="closeModal()">
              <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
